import { render, staticRenderFns } from "./RecordRevisionsBase.vue?vue&type=template&id=54c4b0ac&"
import script from "./RecordRevisionsBase.vue?vue&type=script&lang=js&"
export * from "./RecordRevisionsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports